<template>
    <component :is="SkinComponent" v-model="form" :code="code" v-on="{ remove }" @prev="$emit('prev')" v-if="initiated" />
</template>

<script>
import api from "@/api";
import { APPLICATION_STATUS } from "@/assets/variables";

export default {
    props: {
        skin: { type: String, default: null },
        code: { type: String, default: null },
    },

    data() {
        return {
            form: {},
            initiated: false,
        };
    },

    computed: {
        SkinComponent() {
            return () => import(`./skin/studio-apply/remove.vue`);
        },
    },

    mounted() {
        this.init();
    },

    methods: {
        async init() {
            this.initiated = false;

            let { _form } = this.$attrs;
            if (!_form) this.form = {};
            else {
                let { application } = await api.v1.apply.applications.get({ _id: _form });
                if (application) {
                    application.name = null;
                    application.phone = null;
                    application.applyDate = application.applyDate?.toDate?.();
                }
                this.form = application;
            }

            this.initiated = true;
        },
        async remove(value) {
            this.form = { ...value };
            try {
                if (!this.validation()) return;

                let { _id, name, phone } = this.form;
                let form = {
                    _id,
                    name,
                    phone,
                    status: APPLICATION_STATUS.CANCELED.value,
                };

                await api.v1.apply.applications.put(form);

                alert("취소가 완료되었습니다.");

                if (isCreate) this.$router.go(-1);
                else this.$emit("prev");
            } catch (error) {
                console.error(error.message);
            }
        },
        validation() {
            if (!this.form.name) throw new Error("이름을 입력해주세요");
            if (!this.form.phone) throw new Error("연락처를 입력해주세요");

            return true;
        },
    },
};
</script>
